module.exports = __webpack_public_path__ + "img/extended.15ac1e96.png";